import React from 'react';

const ReportImage = ({
  reportKey,
  imageRef
}) => {

  return <img ref={imageRef} />
};


export default ReportImage;
